import React, { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

import { z } from 'zod';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';
import { ETemplateStudioLayoutOptions } from 'components/TemplatesStudio/enums';
import { FormControl, FormField, FormItem, FormMessage } from 'components/ui';

import { templateStudioSchema } from '../../../validation-schema';
import { ThemesFormItem } from '../Components/ThemesFormItem';

export const TemplateStudioRollingOffersForm: React.FC = () => {
  const { control, watch } =
    useFormContext<z.infer<typeof templateStudioSchema>>();

  const desktopLayoutOptions = useMemo(
    () =>
      Object.values(ETemplateStudioLayoutOptions).map((value) => ({
        value,
        label: value
      })),
    []
  );

  return (
    <>
      <FormField
        control={control}
        name="rollingOffers.desktopLayout"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <div className="flex items-center justify-between mt-2">
                <span className="text-xs text-black whitespace-nowrap">
                  Desktop layout
                </span>
                <div className="w-[120px]">
                  <InputSelectDropdown
                    options={desktopLayoutOptions}
                    defaultSelected={desktopLayoutOptions.find(
                      (layout) =>
                        layout.value === watch('rollingOffers.desktopLayout')
                    )}
                    onOptionChange={field.onChange}
                    placeholder="Select product display"
                    isHorizontal={true}
                    buttonClassName={'h-[30px]'}
                  />
                </div>
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="rollingOffers.themes"
        render={({ field }) => (
          <ThemesFormItem onChange={field.onChange} value={field.value || []} />
        )}
      />
    </>
  );
};
